import type { AcademyApi } from '@mathflat/domain/@entities/Academy/api'

import { mpEventInfo } from '@/constant'
import type { DefaultResponse } from '@/types/common'
import maxios from '@/utils/axios/maxios'

type ResponseAcademy = DefaultResponse<res.Academy>

// 기관 API
const academyApi = {
  // 기관 가져오기
  getAcademies() {
    return maxios.get<ResponseAcademy>('/academies', {
      params: { mp_event_name: mpEventInfo.학원정보가져오기 },
    })
  },
  // 기관 수정하기
  patchAcademies(data: req.Academy) {
    return maxios.patch('/academies', data, {
      params: { mp_event_name: mpEventInfo.학원정보수정 },
    })
  },
  // 기관 로고 수정하기
  patchLogo(data: req.AcademyLogo) {
    return maxios.patch('/academies/logo', data, {
      headers: { 'Content-Type': 'multipart/form-data' },
      params: { mp_event_name: mpEventInfo.로고수정 },
    })
  },
  // patchAcademies는 고객정보 수정 시 사용하고, patchCustomerType은 4주간만 띄우는 팝업에서 사용하기 때문에 분리함
  patchCustomerType(data: req.AcademyCustomerType) {
    return maxios.patch('/academies', data, {
      params: { mp_event_name: mpEventInfo.학원정보수정 },
    })
  },

  // 핸드폰 인증을 위한 파라미터 (Encodedata) 얻기 v2
  getEncodeNiceInfo(params: req.GetEncodeNiceData) {
    return maxios.get('/academies/encoded-nice-info', {
      params: {
        successRedirectUrl: params.successRedirectUrl,
        failRedirectUrl: params.failRedirectUrl,
        mp_event_name: mpEventInfo.SMS핸드폰인증,
      },
    })
  },

  // NICE 인증 성공 후 발신번호 변경을 요청한다
  // 사용자 정보 복호화 및 Draft 저장
  patchNiceAuthSuccess({ encodeData }: req.EncodeData, type: req.NiceAuthSuccessType) {
    return maxios.patch<DefaultResponse<res.NiceAuthSuccess>>(
      `/academies/nice-auth-success/${type}`,
      encodeData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        params: { mp_event_name: mpEventInfo.NICE인증발신번호등록 },
      },
    )
  },

  postMetaData: async (data: req.AcademyMetaData) => {
    return maxios.post('/academies/metadata', data, {
      params: { mp_event_name: mpEventInfo.내정보수정 },
    })
  },
  patchMetaData: async (data: req.AcademyAttendanceSmsService) => {
    return maxios.patch('/academies/metadata', data, {
      params: { mp_event_name: mpEventInfo.학원메타데이터수정 },
    })
  },
  putMetaData: async <T extends 'v1' | 'v2'>(
    data: T extends 'v1' ? req.PutAcademyMetaData : req.AcademyMetaDataV2,
    version: T = 'v2' as T,
  ) => {
    if (version === 'v1') {
      return maxios.put('/academies/metadata', data, {
        params: { mp_event_name: mpEventInfo.학원메타데이터수정 },
      })
    }
    return maxios.put('/academies/metadata/v2', data, {
      params: { mp_event_name: mpEventInfo.학원메타데이터수정 },
    })
  },
  postFreePremium: async (data: req.FreePremium) => {
    return maxios.post('/academies/free-premium', data, {
      params: { mp_event_name: mpEventInfo.프리미엄체험신청 },
    })
  },
  getSettlementWithIdentification: async () => {
    return maxios.get<DefaultResponse<res.SettlementWithIdentification>>(
      '/academies/settlement-with-identification',
    )
  },
  putAdditionalData: async (data: res.Academy['academyAdditionalData']) => {
    return maxios.put('/academies/additional-data', data, {
      params: { mp_event_name: mpEventInfo.학원정보수정 },
    })
  },

  postSubscriptionOffer: (
    data: AcademyApi.Request.SubscriptionOffer,
    token: string,
    academyId: string,
  ) => {
    return maxios.post(`/academies/${academyId}/subscription-offer`, data, {
      headers: { 'x-subscription-offer-token': token },
    })
  },
}
export default academyApi
